module.exports = __webpack_public_path__ + "static/media/SiteBuilder-Screenshot-2.7ddf1443.png";